module.exports = {
      id: "plus-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#plus",
      toString: function () {
        return this.url;
      }
    }